import { render, staticRenderFns } from "./HistoryEightHolter.vue?vue&type=template&id=c255ef06&scoped=true"
import script from "./HistoryEightHolter.vue?vue&type=script&lang=js"
export * from "./HistoryEightHolter.vue?vue&type=script&lang=js"
import style0 from "./HistoryEightHolter.vue?vue&type=style&index=0&id=c255ef06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c255ef06",
  null
  
)

export default component.exports